module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDeelnemen5FA7C4.799c103d.png";